import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <div className=" bg-dark mt-5">
      <div className="container">
        <div className="row py-2">
          <div className="col-md-8">
            <h5 className="text-warning">
              XL Calendrier est une marque{" "}
              <Link className="text-light" to="https://xl-triathlon.fr">
                XL Triathlon
              </Link>
            </h5>
            <p className="text-light">Mentions légales</p>
          </div>
          <div className="col-md-4 text-light">
            <p>Tous droits réservés XL Triathlon</p>
            <p>
              Crédits :{" "}
              <Link to="https://www.vecteezy.com/free-vector/bike">
                Vectors by Vecteezy
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
